(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["items-back-to-top"] && !Shopify.designMode) return;
  try {
    (function() {
    var button = document.querySelector('.items-back-to-top');
    if (!button) return;
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var pending = false;
    var returnFocus = false;

    function updateVisibility() {
      pending = false;
      button.hidden = window.scrollY < 480;
      if (returnFocus && window.scrollY <= 2) {
        returnFocus = false;
        var headerLink = document.querySelector('.header__heading-link');
        if (headerLink) headerLink.focus({ preventScroll: true });
      }
    }

    window.addEventListener('scroll', function() {
      if (pending) return;
      pending = true;
      window.requestAnimationFrame(updateVisibility);
    }, { passive: true });

    button.addEventListener('click', function() {
      returnFocus = true;
      window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      updateVisibility();
    });

    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(function(eventName) {
      window.addEventListener(eventName, function() { returnFocus = false; }, { passive: true });
    });
    window.addEventListener('pageshow', updateVisibility);
    updateVisibility();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["items-catalog-support"] && !Shopify.designMode) return;
  try {
    if (!window.ItemsCatalogCards) {
    const requests = new Map();
    const pendingModalIds = new Set();
    const modalRequests = new WeakMap();
    window.ItemsCatalogCards = {
      currentCart: null,
      rememberCart(cartData) {
        if (Array.isArray(cartData?.items)) this.currentCart = cartData;
      },
      loadHomeModal(opener) {
        const modal = document.getElementById(opener.dataset.modal?.slice(1));
        const bulk = modal?.querySelector('bulk-modal[data-items-home-modal]');
        if (!bulk || bulk.querySelector('quick-order-list')) return Promise.resolve();
        if (modalRequests.has(bulk)) return modalRequests.get(bulk);
        bulk.setAttribute('aria-busy', 'true');
        const spinner = opener.querySelector('.loading__spinner')?.cloneNode(true);
        if (spinner) {
          spinner.classList.remove('hidden');
          bulk.replaceChildren(spinner);
        }
        const pending = (async () => {
          try {
            const url = new URL(bulk.dataset.url, window.location.href);
            url.searchParams.set('section_id', 'bulk-quick-order-list');
            const response = await fetch(url.href);
            if (!response.ok) throw new Error('home-modal-request-failed');
            const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = parsed.querySelector('.quick-order-list-container');
            if (!content?.querySelector('quick-order-list')) throw new Error('home-modal-content-missing');
            content.querySelectorAll('script, link[rel="stylesheet"]').forEach(node => node.remove());
            bulk.innerHTML = content.outerHTML;
          } catch (error) {
            const link = document.createElement('a');
            link.className = 'button button--secondary';
            link.href = bulk.dataset.url;
            link.textContent = opener.querySelector('button')?.textContent.trim() || modal.getAttribute('aria-label') || bulk.dataset.url;
            bulk.replaceChildren(link);
          } finally {
            bulk.setAttribute('aria-busy', 'false');
            modalRequests.delete(bulk);
          }
        })();
        modalRequests.set(bulk, pending);
        return pending;
      },
      async fetchPage(baseUrl, sort, page) {
        const url = new URL(baseUrl, window.location.href);
        url.searchParams.set('sort_by', sort);
        url.searchParams.set('page', String(page));
        url.searchParams.set('section_id', 'items-catalog-feed');
        const key = url.href;
        if (!requests.has(key)) {
          const pending = (async () => {
            const response = await fetch(url.href, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
            if (!response.ok) throw new Error('catalog-request-failed');
            const html = await response.text();
            const parsed = new DOMParser().parseFromString(html, 'text/html');
            const feed = parsed.querySelector('[data-items-catalog-feed]');
            if (!feed) throw new Error('catalog-feed-missing');
            const items = [...feed.querySelectorAll('[data-items-feed-card]')].map(card => ({
              id: card.dataset.productId,
              url: card.dataset.productUrl,
              sectionId: feed.dataset.sectionId,
              html: card.outerHTML
            }));
            if (items.length > 18 || items.some(item => !item.id || !item.url)) throw new Error('catalog-feed-invalid');
            return { items, next: Boolean(feed.dataset.nextUrl) };
          })();
          requests.set(key, pending);
          pending.catch(() => requests.delete(key));
        }
        return requests.get(key);
      },
      prepareCard(item, prefix) {
        const parsed = new DOMParser().parseFromString(`<ul>${item.html}</ul>`, 'text/html');
        const card = parsed.querySelector('ul > li');
        if (!card) throw new Error('catalog-card-missing');
        card.className = 'grid__item collection-quick-add-bulk';
        card.dataset.id = item.sectionId;
        card.dataset.url = item.url;
        card.dataset.productId = item.id;
        card.dataset.itemsHomeCard = 'true';
        card.removeAttribute('style');
        card.removeAttribute('data-cascade');
        card.querySelectorAll('script, link[rel="stylesheet"]').forEach(node => node.remove());
        const canonicalOpeners = new Set();
        card.querySelectorAll('modal-dialog').forEach(modal => {
          const modalId = modal.id;
          if (document.getElementById(modalId) || pendingModalIds.has(modalId)) {
            modal.remove();
          } else {
            pendingModalIds.add(modalId);
            modal.querySelectorAll('bulk-modal').forEach(bulk => {
              bulk.dataset.itemsHomeModal = 'true';
              if (!bulk.innerHTML.trim()) {
                const placeholder = parsed.createElement('span');
                placeholder.hidden = true;
                bulk.append(placeholder);
              }
            });
            card.querySelectorAll('modal-opener').forEach(opener => {
              if (opener.dataset.modal === `#${modalId}`) canonicalOpeners.add(opener.id);
            });
          }
        });
        const ids = new Map();
        [card, ...card.querySelectorAll('[id]')].forEach(element => {
          if (!element.id || element.closest('modal-dialog') || canonicalOpeners.has(element.id)) return;
          if (element.localName === 'quick-add-bulk') {
            element.dataset.canonicalId = element.id;
            element.dataset.itemsInstancePrefix = prefix;
          }
          ids.set(element.id, `${prefix}-${element.id}`);
          element.id = ids.get(element.id);
        });
        card.querySelectorAll('*').forEach(element => {
          if (element.closest('modal-dialog')) return;
          ['for', 'form', 'aria-labelledby', 'aria-describedby', 'aria-controls', 'aria-owns'].forEach(attribute => {
            if (element.hasAttribute(attribute)) {
              element.setAttribute(attribute, element.getAttribute(attribute).split(' ').map(id => ids.get(id) || id).join(' '));
            }
          });
          if (element.dataset.modal?.startsWith('#') && ids.has(element.dataset.modal.slice(1))) {
            element.dataset.modal = `#${ids.get(element.dataset.modal.slice(1))}`;
          }
        });
        card.querySelectorAll('.card__media img').forEach(image => {
          image.loading = 'lazy';
          image.sizes = '(min-width: 990px) calc((100vw - 60px) / 6), (min-width: 750px) calc((100vw - 40px) / 4), calc((100vw - 24px) / 2)';
        });
        const prepared = document.importNode(card, true);
        prepared.querySelectorAll('modal-opener[data-modal]').forEach(opener => {
          opener.addEventListener('click', () => this.loadHomeModal(opener), { capture: true });
        });
        return prepared;
      },
      releaseClaims() {
        pendingModalIds.clear();
      }
    };
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const cartData = event.cartData;
      if (Array.isArray(cartData?.items) && (event.source === 'quick-add' || 'item_count' in cartData || 'token' in cartData)) {
        window.ItemsCatalogCards.rememberCart(cartData);
      }
    });
    customElements.define('items-catalog-support', class extends HTMLElement {});
  }
  } catch(e) { console.error(e); }
})();

})();
